<template>
	<div class="detaill margin-left">
		<div class="flex bg-white list-item margin-bottom-sm">
			<img class="cover margin-right-sm" :src="logo" >
			<div class="text-left flex flex-sub flex-direction justify-between">
				<div class="titlw">{{title}}</div>
				<p class="text-sm text-666">课程章节：共{{chapterCount}}节</p>
				<div class="flex align-center justify-between">
					<p class="text-price priced text-bold text-prices">{{pay_price}}</p>
					<div class="flex align-center">
						<p @click="del" class="text-center text-sm text-666 margin-right-sm del pointer">删除课程</p>
						<p @click="edit" class="text-center text-sm margin-right-sm editbtn text-white pointer">编辑课程</p>
						<!-- <p class="text-center text-sm shelfbtn text-white pointer">立即上架</p> -->
						<p @click="undercarriage" v-if="status == 0" class="text-center text-sm shelfbtn text-white pointer">重新上架</p>
						<p @click="undercarriage" v-if="status == 1" class="text-center text-sm shelfbtn text-white pointer">立即下架</p>
						
					</div>
				</div>
			</div>
			<div v-if="status == 0" class="status paied">已下架</div>
			<div v-if="status == 1" class="status paied">已上架</div>
		</div>
		<div class="bg-white deinfo">
			<div class="flex align-center info-title">
				<p class="pointer" @click="infoindex = 0" :class="infoindex == 0?'text-theme actve':''">课程介绍</p>
				<p class="pointer" @click="infoindex = 1" :class="infoindex == 1?'text-theme actve':''">课程目录</p>
			</div>
			<div class="padding-lg" v-if="infoindex == 0">
				<div v-html="content"></div>
			</div>
			<div class="padding" v-if="infoindex == 1">
				<div class="flex align-center margin-bottom-sm justify-between" v-for="(item,index) in chapter" :key="index">
					<div class="flex align-center">
						<img class="broadcast margin-right-xs" src="../../../assets/img/broadcast.png" >
						<p>{{item.chapter_title}}</p>
					</div>
					<p v-if="item.is_free == 1" @click.stop="setfree(item,0)" class="set-btn pointer text-theme text-sm">设为免费</p>
					<p v-if="item.is_free == 0" @click.stop="setfree(item,1)" class="cal-btn pointer text-666 text-sm">取消免费</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				infoindex:0,
				content:'',
				id:'',
				logo:'',
				pay_price:'',
				title:'',
				type:'',
				course_id:0,//课程id
				status:0,
				chapterCount:0,
				chapter:[],
				apply_id:0,//
			};
		},
		created() {
			Bus.$on('getmindid',data=>{
				this.id = data
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('getmindid')
		},
		methods: {
			/**
			 * 详情
			 * */
			getdetail(){
				this.ajax('get', '/api/course/getMyCourseInfo',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.content = res.data.content
						this.chapterCount = res.data.chapterCount
						this.chapter = res.data.chapter
						this.pay_price = res.data.price
						this.type = res.data.type
						this.logo = res.data.logo
						this.title = res.data.title
						this.status = res.data.status
						this.apply_id = res.data.apply_id
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 设置免费
			 * */
			setfree(ele,type){
				this.ajax('post', '/api/courseapply/editChatper',{
					course_id:this.apply_id,
					chapter_title:ele.chapter_title,
					resources:ele.resources,
					id:ele.id,
					is_free:type
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.$message('设置已提交审核');
						this.getdetail()
					}else{
						this.$message(res.msg);
					}
				})
			
			},
			/**
			 * 去编辑
			 * */
			edit(){
				let typeq = {
					type:'curlease',
					typeone:''
				}
				this.$emit('gettype',typeq)
				setTimeout(()=>{
					let inf ={
						id:this.apply_id,
						isedit:1
					}
					Bus.$emit('getdexatail',inf)
				},500)
			},
			/**
			 * 上下架
			 * */
			undercarriage(){
				this.ajax('post', '/api/course/editShelf',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data.status == 200){
							this.$message('设置成功');
							this.getdetail()
							
						}
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 删除
			 * */
			del(){
				this.ajax('post', '/api/course/delete',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data.status == 200){
							this.$message('删除成功');
						}
					}else{
						this.$message(res.msg);
					}
				})
				
			}
		}
	}
</script>

<style scoped lang="less">
	.detaill{
		width: 921px;
	}
	.bohui{
		font-size: 26px;
	}
	.list-item{
		padding: 30px;
		border-radius: 20px;
		width: 921px;
		position: relative;
		.status{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.paied{
			background: rgba(11,131,124,0.1000);
			color: #0B837C;
		}
		.del{
			width: 98px;
			height: 45px;
			line-height: 45px;
			background: #FFFFFF;
			border: 1px solid #DADADA;
			border-radius: 23px;
		}
		.editbtn{
			width: 98px;
			height: 45px;
			line-height: 45px;
			background: #1299E4;
			border-radius: 23px;
		}
		.shelfbtn{
			width: 193px;
			height: 45px;
			line-height: 45px;
			background: #0B837C;
			border-radius: 23px;
		}
		
		.priced{
			font-size: 34px;
		}
	}
	.cover{
		width: 104px;
		height: 133px;
	}
	.titlw{
		font-size: 26px;
	}
	.set-btn{
		width: 113px;
		height: 36px;
		line-height: 36px;
		background: rgba(3,169,160,0.1);
		border: 1px solid #03A9A0;
		border-radius: 23px;
	}
	.cal-btn{
		width: 113px;
		height: 46px;
		line-height: 46px;
		background: rgba(255,255,255,0.1);
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.broadcast{
		width: 26px;
		height: 26px;
	}
	.audition{
		width: 44px;
		height: 24px;
		line-height: 24px;
		background: #0B837C;
		border-radius: 6px;
	}
	.actve{
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			content: '';
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
		}
	}
	.info-title{
		width: 920px;
		height: 69px;
		background: #F7F6F6;
		border-radius: 20px 20px 0px 0px;
		p{
			width: 120px;
			height: 69px;
			line-height: 69px;
		}
	}
	.deinfo{
		box-shadow: 2px 3px 29px 1px rgba(201,199,199,0.3000);
		border-radius: 20px;
		min-height: 650px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/course/minedetail.vue